<template>
  <div>
    <!-- heading starts -->
    <v-row class="mt-1 mx-1" align-content="space-between">
      <v-col cols="6" md="5" sm="6">
        <p class="body-1 text--primary">LineUp Teams:</p>
        &nbsp;
      </v-col>

      <!-- <p>{{ JsonFormat }}</p> -->

      <!--//! export to pdf -->
      <!-- <v-col cols="4" md="2">
        <v-btn
          small
          class="ml-4 btn-help-video"
          color="info"
          @click="generateReport"
        >
          Export
        </v-btn>
      </v-col> -->

      <v-spacer></v-spacer>
      <v-col cols="5" md="2" sm="6">
        <download-csv
          :data="this.JsonFormat"
          :advancedOptions="{ header: false }"
        >
          <v-btn
            small
            rounded
            class="ml-6 btn-help-video"
            color="success"
            @click="checkJson"
          >
            CSV Export
          </v-btn>
        </download-csv>
      </v-col>
    </v-row>

    <label class="selection-container">
      &nbsp; Select All Teams
      <input
        type="checkbox"
        v-model="select_all"
        :data-team="LineupBuild.doc._id"
        @change="toggleSelection"
      />
      <span class="checkmark"></span>
    </label>
    <!-- heading ends -->
    <div v-if="buildTeamLoader">
      <v-skeleton-loader
        v-for="n in 4"
        :key="n"
        :loading="buildTeamLoader"
        class="ma-2"
        type="table,paragraph"
        elevation="2"
      >
      </v-skeleton-loader>
    </div>

    <v-sheet v-show="!buildTeamLoader" elevation="3" class="mt-6 mb-2">
      <v-row class="mx-1">
        <!--//! team table -->
        <v-col
          cols="12"
          md="12"
          sm="12"
          class="ma-1"
          style="height: 550px; overflow-y: scroll"
        >
          <!-- <vue-html2pdf
            :show-layout="true"
            :float-layout="false"
            pdf-format="a4"
            :preview-modal="true"
            ref="html2Pdf"
            :pdf-quality="2"
            filename="lineup"
            :paginate-elements-by-height="1474"
            pdf-content-width="100%"
          ></vue-html2pdf> -->
          <div
            v-for="(teams, index) in this.LineupBuild.doc.lineup"
            :key="index"
            class="mt-1"
            slot="pdf-content"
          >
            <label class="selection-container">
              <input
                type="checkbox"
                :value="index"
                class="selected_teams"
                :data-team="LineupBuild.doc._id"
                @change="toggleTeamSelection"
              />
              <span class="checkmark"></span>
            </label>

            <base-title-bar
              elevation="3"
              class="text-center"
              color="#17408B"
              :label="'Team' + ' ' + (index + 1)"
              icon="mdi-star"
            />

            <!-- delete lineup  -->
            <div class="lineup-icon">
              <v-btn icon color="red" @click="removeLineup(index)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
            <!-- delete lineup  -->

            <v-data-table
              :headers="TeamHeaders"
              :items="teams"
              :item-key="teams.PlayerID"
              class="elevation-1 mt-n3"
              :items-per-page="teams.length"
              hide-default-footer
              mobile-breakpoint="0"
            >
              <!-- header -->
              <template
                v-for="h in TeamHeaders"
                v-slot:[`header.${h.value}`]="{ TeamHeaders }"
              >
                <v-tooltip bottom :key="h.text">
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ h.text }}</span>
                  </template>
                  <span>{{ h.hint }}</span>
                </v-tooltip>
              </template>
              <!-- header -->

              <!-- position -->
              <template v-slot:item.DraftKingsPosition="{ index }">
                <!-- <p>{{ LineupBuild.doc.operator }}</p> -->
                <!-- //? Nba... -->
                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NBA'
                  "
                >
                  <p class="caption" v-if="index == 0">PG</p>
                  <p class="caption" v-if="index == 1">SG</p>
                  <p class="caption" v-if="index == 2">SF</p>
                  <p class="caption" v-if="index == 3">PF</p>
                  <p class="caption" v-if="index == 4">C</p>
                  <p class="caption" v-if="index == 5">G</p>
                  <p class="caption" v-if="index == 6">F</p>
                  <p class="caption" v-if="index == 7">UTIL</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NBA'
                  "
                >
                  <p class="caption" v-if="index == 0">CPT</p>
                  <p class="caption" v-if="index == 1">UTIL</p>
                  <p class="caption" v-if="index == 2">UTIL</p>
                  <p class="caption" v-if="index == 3">UTIL</p>
                  <p class="caption" v-if="index == 4">UTIL</p>
                  <p class="caption" v-if="index == 5">UTIL</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NBA'
                  "
                >
                  <p class="caption" v-if="index == 0">PG</p>
                  <p class="caption" v-if="index == 1">PG</p>
                  <p class="caption" v-if="index == 2">SG</p>
                  <p class="caption" v-if="index == 3">SG</p>
                  <p class="caption" v-if="index == 4">SF</p>
                  <p class="caption" v-if="index == 5">SF</p>
                  <p class="caption" v-if="index == 6">PF</p>
                  <p class="caption" v-if="index == 7">PF</p>
                  <p class="caption" v-if="index == 8">C</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NBA'
                  "
                >
                  <p class="caption" v-if="index == 0">MVP</p>
                  <p class="caption" v-if="index == 1">STAR</p>
                  <p class="caption" v-if="index == 2">PRO</p>
                  <p class="caption" v-if="index == 3">UTIL</p>
                  <p class="caption" v-if="index == 4">UTIL</p>
                </template>
                <!-- //? Nba ends... -->

                <!-- //? Mlb... -->
                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'MLB'
                  "
                >
                  <p class="caption" v-if="index == 0">P</p>
                  <p class="caption" v-if="index == 1">P2</p>
                  <p class="caption" v-if="index == 2">C</p>
                  <p class="caption" v-if="index == 3">1B</p>
                  <p class="caption" v-if="index == 4">2B</p>
                  <p class="caption" v-if="index == 5">3B</p>
                  <p class="caption" v-if="index == 6">SS</p>
                  <p class="caption" v-if="index == 7">OF</p>
                  <p class="caption" v-if="index == 8">OF2</p>
                  <p class="caption" v-if="index == 9">OF3</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'MLB'
                  "
                >
                  <p class="caption" v-if="index == 0">MVP</p>
                  <p class="caption" v-if="index == 1">Flex</p>
                  <p class="caption" v-if="index == 2">Flex2</p>
                  <p class="caption" v-if="index == 3">Flex3</p>
                  <p class="caption" v-if="index == 4">Flex4</p>
                  <p class="caption" v-if="index == 5">Flex5</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'MLB'
                  "
                >
                  <p class="caption" v-if="index == 0">P</p>
                  <p class="caption" v-if="index == 1">C/1B</p>
                  <p class="caption" v-if="index == 2">2B</p>
                  <p class="caption" v-if="index == 3">3B</p>
                  <p class="caption" v-if="index == 4">SS</p>
                  <p class="caption" v-if="index == 5">OF</p>
                  <p class="caption" v-if="index == 6">OF2</p>
                  <p class="caption" v-if="index == 7">OF3</p>
                  <p class="caption" v-if="index == 8">UTIL</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'MLB'
                  "
                >
                  <p class="caption" v-if="index == 0">MVP</p>
                  <p class="caption" v-if="index == 1">UTIL</p>
                  <p class="caption" v-if="index == 2">UTIL2</p>
                  <p class="caption" v-if="index == 3">UTIL3</p>
                  <p class="caption" v-if="index == 4">UTIL4</p>
                </template>
                <!-- //? Mlb ends... -->

                <!-- //? Nhl... -->
                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NHL'
                  "
                >
                  <p class="caption" v-if="index == 0">C</p>
                  <p class="caption" v-if="index == 1">C</p>
                  <p class="caption" v-if="index == 2">W</p>
                  <p class="caption" v-if="index == 3">W</p>
                  <p class="caption" v-if="index == 4">W</p>
                  <p class="caption" v-if="index == 5">D</p>
                  <p class="caption" v-if="index == 6">D</p>
                  <p class="caption" v-if="index == 7">G</p>
                  <p class="caption" v-if="index == 8">UTIL</p>
                </template>
                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NHL'
                  "
                >
                  <p class="caption" v-if="index == 0">Cpt</p>
                  <p class="caption" v-if="index == 1">Flex</p>
                  <p class="caption" v-if="index == 2">Flex</p>
                  <p class="caption" v-if="index == 3">Flex</p>
                  <p class="caption" v-if="index == 4">Flex</p>
                  <p class="caption" v-if="index == 5">Flex</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NHL'
                  "
                >
                  <p class="caption" v-if="index == 0">C</p>
                  <p class="caption" v-if="index == 1">C</p>
                  <p class="caption" v-if="index == 2">W</p>
                  <p class="caption" v-if="index == 3">W</p>
                  <p class="caption" v-if="index == 4">D</p>
                  <p class="caption" v-if="index == 5">D</p>
                  <p class="caption" v-if="index == 6">Util</p>
                  <p class="caption" v-if="index == 7">Util</p>
                  <p class="caption" v-if="index == 8">G</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NHL'
                  "
                >
                  <p class="caption" v-if="index == 0">CPT</p>
                  <p class="caption" v-if="index == 1">UTIL</p>
                  <p class="caption" v-if="index == 2">UTIL</p>
                  <p class="caption" v-if="index == 3">UTIL</p>
                  <p class="caption" v-if="index == 4">UTIL</p>
                </template>

                <!-- //? Nhl ends... -->

                <!-- //? Nfl... -->
                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NFL'
                  "
                >
                  <p class="caption" v-if="index == 0">QB</p>
                  <p class="caption" v-if="index == 1">RB</p>
                  <p class="caption" v-if="index == 2">RB1</p>
                  <p class="caption" v-if="index == 3">WR</p>
                  <p class="caption" v-if="index == 4">WR</p>
                  <p class="caption" v-if="index == 5">WR</p>
                  <p class="caption" v-if="index == 6">TE</p>
                  <p class="caption" v-if="index == 7">FLEX</p>
                  <p class="caption" v-if="index == 8">DST</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'DraftKings' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NFL'
                  "
                >
                  <p class="caption" v-if="index == 0">CPT</p>
                  <p class="caption" v-if="index == 1">FLEX</p>
                  <p class="caption" v-if="index == 2">FLEX</p>
                  <p class="caption" v-if="index == 3">FLEX</p>
                  <p class="caption" v-if="index == 4">FLEX</p>
                  <p class="caption" v-if="index == 5">FLEX</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Classic' &&
                    LineupBuild.doc.SportType == 'NFL'
                  "
                >
                  <p class="caption" v-if="index == 0">QB</p>
                  <p class="caption" v-if="index == 1">RB</p>
                  <p class="caption" v-if="index == 2">RB</p>
                  <p class="caption" v-if="index == 3">WR</p>
                  <p class="caption" v-if="index == 4">WR</p>
                  <p class="caption" v-if="index == 5">WR</p>
                  <p class="caption" v-if="index == 6">TE</p>
                  <p class="caption" v-if="index == 7">FLEX</p>
                  <p class="caption" v-if="index == 8">DEF</p>
                </template>

                <template
                  v-if="
                    LineupBuild.doc.operator == 'FanDuel' &&
                    LineupBuild.doc.gametype == 'Single' &&
                    LineupBuild.doc.SportType == 'NFL'
                  "
                >
                  <p class="caption" v-if="index == 0">MVP</p>
                  <p class="caption" v-if="index == 1">FLEX</p>
                  <p class="caption" v-if="index == 2">FLEX</p>
                  <p class="caption" v-if="index == 3">FLEX</p>
                  <p class="caption" v-if="index == 4">FLEX</p>
                </template>

                <!-- //? Nfl ends... -->
              </template>
              <!-- position-->

              <!-- salary -->
              <template v-slot:item.DraftKingsSalary="{ item }">
                <p v-if="LineupBuild.doc.operator == 'DraftKings'">
                  {{ item.DraftKingsSalary }}
                </p>
                <p v-if="LineupBuild.doc.operator == 'FanDuel'">
                  {{ item.FanDuelSalary }}
                </p>
              </template>
              <!-- salary ends -->

              <!-- OpponentRank -->
              <template v-slot:item.OpponentRank="{ item }" class="mt-1">
                <v-avatar size="25" rounded>
                  <v-icon>mdi-account-group-outline</v-icon>
                </v-avatar>
                <p class="ml-1">{{ item.OpponentRank }}</p>
              </template>
              <!-- OpponentRank ends -->

              <!-- OpponentPositionRank -->
              <template
                v-slot:item.OpponentPositionRank="{ item }"
                class="mt-1"
              >
                <v-avatar size="25" rounded>
                  <v-icon>mdi-shield-account-outline</v-icon>
                </v-avatar>
                <p class="ml-1">{{ item.OpponentPositionRank }}</p>
              </template>
              <!-- OpponentPositionRank ends -->

              <!-- profile image -->
              <template v-slot:item.PhotoUrl="{ item }">
                <v-avatar width="37" height="48">
                  <img :src="item.PhotoUrl" />
                </v-avatar>
              </template>
              <!-- profile image ends -->

              <!-- player name -->
              <template v-slot:item.Name="{ item }">
                <p class="caption" v-if="item.Name === null">{{ item.Team }}</p>
                <router-link
                  :to="{
                    name: 'PlayerDetail',
                    params: { playerId: item.PlayerID, SportId: item.SportId },
                  }"
                  style="text-decoration: none"
                  class="body-2"
                >
                  {{ item.Name }}
                </router-link>
              </template>
              <!-- player name ends -->

              <!-- matchup -->
              <template v-slot:item.Team="{ item }">
                <p>{{ item.Team }}&nbsp;</p>
              </template>
              <!-- matchup ends -->

              <template v-slot:item.HomeOrAway="{ item }">
                <!-- Blue dot - 'active',
                green dot - 'positive',
                yellow dot -'intermediary'
                red dot - 'negative' -->

                <v-row>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == null"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>Healthy</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-show="item.InjuryStatus == 'Out'"
                        v-on="on"
                        v-bind="attrs"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>Out</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Questionable'"
                      >
                        <status-indicator status="intermediary" pulse />
                      </v-col>
                    </template>
                    <span>Questionable</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.InjuryStatus == 'Probable'"
                      >
                        <status-indicator status="active" pulse />
                      </v-col>
                    </template>
                    <span>Probable</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-bind="attrs"
                        v-show="item.HomeOrAway == 'HOME'"
                      >
                        <status-indicator status="positive" pulse />
                      </v-col>
                    </template>
                    <span>HOME</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-col
                        cols="2"
                        md="3"
                        sm="1"
                        v-on="on"
                        v-show="item.HomeOrAway == 'AWAY'"
                      >
                        <status-indicator status="negative" pulse />
                      </v-col>
                    </template>
                    <span>AWAY</span>
                  </v-tooltip>
                </v-row>
              </template>

              <!-- FPPG -->
              <template v-slot:item.FPPG="{ item }">
                <p class="body-2">{{ item.FPPG >> 0 }}</p>
              </template>
              <!-- FPPG -->

              <!-- projection -->
              <template v-slot:item.DraftKingsProjection="{ item }">
                <p class="body-2">{{ item.DraftKingsProjection >> 0 }}</p>
              </template>
              <!-- projection ends -->

              <!-- lock line up -->
              <template v-slot:item.swap="{ item }">
                <v-btn x-small fab color="blue" dark class="ml-2">
                  <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
              </template>
              <!-- lock line up ends-->

              <!-- min% -->
              <template v-slot:item.min="{ item }">
                <v-text-field
                  class="mt-1 minimun"
                  dense
                  solo
                  placeholder="0"
                ></v-text-field>
              </template>
              <!-- min% ends -->

              <!-- max% -->
              <template v-slot:item.max="{ item }">
                <v-text-field
                  class="mt-1 maximum"
                  solo
                  dense
                  placeholder="100"
                ></v-text-field>
              </template>
              <!-- max% ends -->

              <!-- slatePlayerID -->
              <template v-slot:item.SlatePlayerID="{ item }">
                <p class="body-2">{{ item.SlatePlayerID }}</p>
              </template>
              <!-- slatePlayerID -->
            </v-data-table>
          </div>

          <!-- <small>{{ JsonFormat }}</small> -->
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
//   import VueHtml2pdf from "vue-html2pdf";
import NbaNavbar from "@/layout/NBA-panel/NbaLayout.vue";
import { mapGetters } from "vuex";
export default {
  name: "nbaLineUpBuild",
  components: { NbaNavbar },
  props: {
    LineupBuild: {
      type: [Object, Array],
      default: () => {},
    },
    saveBuildId: {
      type: String,
      required: true,
    },
  },
  // components: {
  //   VueHtml2pdf,
  // },
  computed: {
    ...mapGetters("NbaModule", ["buildTeamLoader"]),
  },

  watch: {
    LineupBuild: {
      deep: true,
      handler(newValue) {
        let self = this;
        // delay script by 500ms as DOM is not populated
        setTimeout(function () {
          // current line up id
          let build_id = newValue.doc._id;
          // line up index
          let build_index = self.$parent.selected_lineup.findIndex(
            (build) => Object.keys(build)[0] == build_id
          );

          document
            .querySelectorAll(".selected_teams")
            .forEach(function (team, index) {
              // selected index
              let values = Object.values(
                self.$parent.selected_lineup[build_index]
              )[0];

              if (values.includes(index)) {
                team.checked = true;
              } else {
                team.checked = false;
              }
            });
        }, 500);
        this.JsonFormat = [];
        //console.log('watcher lineupBuild', this.LineupBuild);
      },
    },
  },

  data() {
    return {
      select_all: false,
      JsonFormat: [],
      userId: localStorage.getItem("user"),
      position: ["PG", "SG", "SF", "PF", "C", "G", "F", "UTIL"],
      selection: "PG",
      TeamHeaders: [
        {
          text: "Profile",
          value: "PhotoUrl",
          sortable: false,
          hint: "profile",
        },
        {
          text: "Position",
          value: "DraftKingsPosition",
          sortable: false,
          hint: "position",
        },
        { text: "Player", value: "Name", sortable: false, hint: "player" },
        { text: "Team", value: "Team", sortable: false, hint: "team" },
        { text: "Status", value: "HomeOrAway", sortable: false, hint: "" },
        {
          text: "Salary($)",
          value: "DraftKingsSalary",
          sortable: false,
          hint: "salary",
        },
        {
          text: "FPPG",
          value: "FPPG",
          sortable: false,
          hint: "Fantasy point per game",
        },
        {
          text: "Proj.",
          value: "DraftKingsProjection",
          sortable: false,
          hint: "projection",
        },
      ],
    };
  },
  methods: {
    removeLineup(index) {
      // debugger;
      // array which we want to remove...
      this.LineupBuild.doc.lineup.splice(index, 1);
      let sportsId = this.LineupBuild.doc.SportId;
      let obj = {
        dataid: this.saveBuildId,
        user: this.userId,
        lineup: this.LineupBuild.doc.lineup,
      };

      if (sportsId == "1") {
        this.$store.dispatch("NbaModule/updateSavedLineup", obj);
      } else if (sportsId == "2") {
        this.$store.dispatch("MlbModule/updateSavedLineup", obj).then(() => {
          //console.log('length', this.LineupBuild.doc);
        });
      } else if (sportsId == "3") {
        this.$store.dispatch("NhlModule/updateSavedLineup", obj).then(() => {
          //console.log('length', this.LineupBuild.doc);
        });
      } else if (sportsId == "4") {
        this.$store.dispatch("NflModule/updateSavedLineup", obj).then(() => {
          //console.log('length', this.LineupBuild.doc);
        });
      }
    },

    checkJson() {
      let self = this;
      this.JsonFormat = [];
      let header = [];

      // * NBA...
      if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NBA"
      ) {
        header = ["PG", "SG", "SF", "PF", "C", "G", "F", "UTIL"];
        // //console.log(header);
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NBA"
      ) {
        header = ["PG", "PG", "SG", "SG", "SF", "SF", "PF", "PF", "C"];
        // //console.log(header);
      } else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NBA"
      ) {
        header = ["CPT", "UTIL", "UTIL", "UTIL", "UTIL", "UTIL"];
        // //console.log(header);
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NBA"
      ) {
        header = [
          "MVP - 2X Points",
          "STAR - 1.5X Points",
          "PRO - 1.2X Points",
          "UTIL",
          "UTIL",
        ];
      }

      // * MLB...
      else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "MLB"
      ) {
        header = ["P", "P", "C", "1B", "2B", "3B", "SS", "OF", "OF", "OF"];
      } else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "MLB"
      ) {
        header = ["CPT", "UTIL", "UTIL", "UTIL", "UTIL", "UTIL"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "MLB"
      ) {
        header = ["P", "C/1B", "2B", "3B", "SS", "OF", "OF", "OF", "UTIL"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "MLB"
      ) {
        header = [
          "MVP - 2X Points",
          "UTIL - 1.5X Points",
          "UTIL",
          "UTIL",
          "UTIL",
        ];
      }

      // * NHL...
      else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NHL"
      ) {
        header = ["C", "C", "W", "W", "W", "D", "D", "G", "UTIL"];
      } else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NHL"
      ) {
        header = ["CPT", "FLEX", "FLEX", "FLEX", "FLEX", "FLEX"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NHL"
      ) {
        header = ["C", "C", "W", "W", "D", "D", "UTIL", "UTIL", "G"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NHL"
      ) {
        header = ["Captain - 1.5x Pts", "UTIL", "UTIL", "UTIL", "UTIL"];
      }

      // * NFL...
      else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NFL"
      ) {
        header = ["QB", "RB", "RB", "WR", "WR", "WR", "TE", "FLEX", "DST"];
      } else if (
        this.LineupBuild?.doc?.operator == "DraftKings" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NFL"
      ) {
        header = ["CPT", "FLEX", "FLEX", "FLEX", "FLEX", "FLEX"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Classic" &&
        this.LineupBuild?.doc?.SportType == "NFL"
      ) {
        header = ["QB", "RB", "RB", "WR", "WR", "WR", "TE", "FLEX", "DEF"];
      } else if (
        this.LineupBuild?.doc?.operator == "FanDuel" &&
        this.LineupBuild?.doc?.gametype == "Single" &&
        this.LineupBuild?.doc?.SportType == "NFL"
      ) {
        header = [
          "MVP - 1.5X Points",
          "AnyFLEX",
          "AnyFLEX",
          "AnyFLEX",
          "AnyFLEX",
        ];
      }
      // append header
      this.JsonFormat.push(header);

      // iterate each selected lineup
      this.$parent.selected_lineup.forEach(function (team) {
        let build_id = Object.keys(team)[0];
        let selected_team = Object.values(team)[0];

        if (selected_team.length > 0) {
          // all team
          let teams = self.$parent.all_lineup_teams[build_id];

          teams.map(function (item, index) {
            // match build lineup id

            // * NBA...
            if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NBA"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;
              let slatePlayer7 = `${item[6].Name} (${item[6].SlatePlayerID})`;
              let slatePlayer8 = `${item[7].Name} (${item[7].SlatePlayerID})`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NBA"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NBA"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              let slatePlayer6 = `${item[5].SlatePlayerID}:${item[5].Name}`;
              let slatePlayer7 = `${item[6].SlatePlayerID}:${item[6].Name}`;
              let slatePlayer8 = `${item[7].SlatePlayerID}:${item[7].Name}`;
              let slatePlayer9 = `${item[8].SlatePlayerID}:${item[8].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NBA"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
              ]);
            }

            // * MLB...
            else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "MLB"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;
              let slatePlayer7 = `${item[6].Name} (${item[6].SlatePlayerID})`;
              let slatePlayer8 = `${item[7].Name} (${item[7].SlatePlayerID})`;
              let slatePlayer9 = `${item[8].Name} (${item[8].SlatePlayerID})`;
              let slatePlayer10 = `${item[9].Name} (${item[9].SlatePlayerID})`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
                slatePlayer10,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "MLB"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;

              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "MLB"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              let slatePlayer6 = `${item[5].SlatePlayerID}:${item[5].Name}`;
              let slatePlayer7 = `${item[6].SlatePlayerID}:${item[6].Name}`;
              let slatePlayer8 = `${item[7].SlatePlayerID}:${item[7].Name}`;
              let slatePlayer9 = `${item[8].SlatePlayerID}:${item[8].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "MLB"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
              ]);
            }

            // * NHL...
            else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NHL"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;
              let slatePlayer7 = `${item[6].Name} (${item[6].SlatePlayerID})`;
              let slatePlayer8 = `${item[7].Name} (${item[7].SlatePlayerID})`;
              let slatePlayer9 = `${item[8].Name} (${item[8].SlatePlayerID})`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NHL"
            ) {
              let slatePlayer1 = `${item[0].Name}-CPT (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;

              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NHL"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              let slatePlayer6 = `${item[5].SlatePlayerID}:${item[5].Name}`;
              let slatePlayer7 = `${item[6].SlatePlayerID}:${item[6].Name}`;
              let slatePlayer8 = `${item[7].SlatePlayerID}:${item[7].Name}`;
              let slatePlayer9 = `${item[8].SlatePlayerID}:${item[8].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NHL"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name} - CPT`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
              ]);
            }

            // * NFl...
            else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NFL"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;
              let slatePlayer7 = `${item[6].Name} (${item[6].SlatePlayerID})`;
              let slatePlayer8 = `${item[7].Name} (${item[7].SlatePlayerID})`;
              let slatePlayer9 = `${item[8].Team} (${item[8].SlatePlayerID})`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "DraftKings" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NFL"
            ) {
              let slatePlayer1 = `${item[0].Name} (${item[0].SlatePlayerID})`;
              let slatePlayer2 = `${item[1].Name} (${item[1].SlatePlayerID})`;
              let slatePlayer3 = `${item[2].Name} (${item[2].SlatePlayerID})`;
              let slatePlayer4 = `${item[3].Name} (${item[3].SlatePlayerID})`;
              let slatePlayer5 = `${item[4].Name} (${item[4].SlatePlayerID})`;
              let slatePlayer6 = `${item[5].Name} (${item[5].SlatePlayerID})`;

              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Classic" &&
              self.LineupBuild?.doc?.SportType == "NFL"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;
              let slatePlayer6 = `${item[5].SlatePlayerID}:${item[5].Name}`;
              let slatePlayer7 = `${item[6].SlatePlayerID}:${item[6].Name}`;
              let slatePlayer8 = `${item[7].SlatePlayerID}:${item[7].Name}`;
              let slatePlayer9 = `${item[8].SlatePlayerID}:${item[8].Team}`;
              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
                slatePlayer6,
                slatePlayer7,
                slatePlayer8,
                slatePlayer9,
              ]);
            } else if (
              selected_team.indexOf(index) !== -1 &&
              self.LineupBuild?.doc?.operator == "FanDuel" &&
              self.LineupBuild?.doc?.gametype == "Single" &&
              self.LineupBuild?.doc?.SportType == "NFL"
            ) {
              let slatePlayer1 = `${item[0].SlatePlayerID}:${item[0].Name}`;
              let slatePlayer2 = `${item[1].SlatePlayerID}:${item[1].Name}`;
              let slatePlayer3 = `${item[2].SlatePlayerID}:${item[2].Name}`;
              let slatePlayer4 = `${item[3].SlatePlayerID}:${item[3].Name}`;
              let slatePlayer5 = `${item[4].SlatePlayerID}:${item[4].Name}`;

              self.JsonFormat.push([
                slatePlayer1,
                slatePlayer2,
                slatePlayer3,
                slatePlayer4,
                slatePlayer5,
              ]);
            }
          });
        }
      });

      // //console.log("teams to export", this.JsonFormat);
      if (this.JsonFormat.length <= 1) {
        alert("NO Team Selceted, Please select a team first");
        return;
      } else {
        return;
      }
    },

    toggleSelection(element) {
      // debugger;
      // current line up id
      let build_id = element.target.getAttribute("data-team");

      // line up index
      let build_index = this.$parent.selected_lineup.findIndex(
        (build) => Object.keys(build)[0] == build_id
      );

      if (!this.select_all) {
        // reset
        this.$parent.selected_lineup[build_index][build_id] = [];
      }

      let self = this;

      document
        .querySelectorAll(".selected_teams")
        .forEach(function (team, index) {
          // toggle selection
          team.checked = self.select_all;

          if (self.select_all) {
            self.$parent.selected_lineup[build_index][build_id].push(index);
          }
        });
    },

    toggleTeamSelection: function (element) {
      let self = this;
      // current line up id
      let build_id = element.target.getAttribute("data-team");
      // line up index
      let build_index = this.$parent.selected_lineup.findIndex(
        (build) => Object.keys(build)[0] == build_id
      );
      // reset
      this.$parent.selected_lineup[build_index][build_id] = [];

      document
        .querySelectorAll(".selected_teams")
        .forEach(function (team, index) {
          // if checkbox checked
          if (team.checked) {
            self.$parent.selected_lineup[build_index][build_id].push(index);
          }
        });
    },
  },
};
</script>

<style scoped>
.minimun {
  font-size: 0.9em;
  min-height: 10px;
  max-width: 60px;
}
.maximum {
  font-size: 0.9em;
  min-height: 10px;
  max-width: 60px;
}

/* The container */
.selection-container {
  display: block;
  position: relative;
  padding-left: 45px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.selection-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 5px;
  left: 15px;
  height: 20px;
  width: 20px;
  background-color: #eee;
}

.lineup-icon {
  position: relative;
  top: -32px;
  left: 40px;
  height: 20px;
  width: 20px;
}

/* On mouse-over, add a grey background color */
.selection-container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a orange background */
.selection-container input:checked ~ .checkmark {
  background-color: #ff9800;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.selection-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.selection-container .checkmark:after {
  left: 5px;
  top: 1px;
  width: 8px;
  height: 15px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
</style>
